export default "__VITE_ASSET__B9vrmpe9__"